// extracted by mini-css-extract-plugin
module.exports = {"SlideShowSlide":"_2cqXp","slideShowSlide":"_2cqXp","bg":"_3cLPa","borderNode":"kRv_X"};